export default __webpack_public_path__ + "static/media/Media-Bulletins.30a96e58.png";